import { Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "../PageState/pageState.scss";

interface ApiErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

/** A centered load failure. It borrows the Serious look (red tile, Rubik title, inverse retry) but keeps its layout. */
export const ApiErrorState: FC<ApiErrorStateProps> = ({
  title,
  description,
  onRetry,
}) => {
  const { t } = useTranslation("common");
  const resolvedTitle = title ?? t("apiError.title");
  const resolvedDescription = description ?? t("apiError.description");
  return (
    <div className="st-page-state">
      <span className="st-page-state__tile st-page-state__tile--error" aria-hidden="true">
        <ExclamationCircleOutlined />
      </span>
      <Typography.Title level={4} style={{ marginBottom: 8 }}>
        {resolvedTitle}
      </Typography.Title>
      <Typography.Paragraph type="secondary" className="st-page-state__text">
        {resolvedDescription}
      </Typography.Paragraph>
      {onRetry && (
        <Button
          size="large"
          className="st-btn-inverse"
          onClick={onRetry}
          style={{ marginTop: 16 }}
        >
          {t("apiError.retry")}
        </Button>
      )}
    </div>
  );
};
